import { SvgIconBase } from "./SvgIconBase";

import React from "react";

const iconData = {
  width: "30px",
  height: "30px",
  fill: "white",
  viewBox: "0 0 65 65",
  path:
  "M63.71,50.12v.47c-.11.7-.13,1.4-.26,2.1a12.36,12.36,0,0,1-9.54,9.74c-.61.12-1.23.15-1.83.26H50.79a.7.7,0,0,0-.32-.06,10.1,10.1,0,0,1-2-.31,12.34,12.34,0,0,1-8-17.48.34.34,0,0,0-.08-.48q-4-4-7.91-8c-.18-.18-.27-.18-.44,0q-4.14,4.18-8.29,8.34a.36.36,0,0,0-.08.47,12.32,12.32,0,0,1-8.31,17.15c-.72.16-1.44.22-2.16.33H11.92a.75.75,0,0,0-.16,0,10.17,10.17,0,0,1-2.51-.44,12.16,12.16,0,0,1-8.7-9.52C.4,52,.4,51.38.29,50.73V50c.1-.72.13-1.45.28-2.16a12.22,12.22,0,0,1,17.82-8.3.41.41,0,0,0,.59-.08q4-4,8-8.06c.21-.21.21-.31,0-.52Q19.08,22.93,11.19,15C9.28,13,7.36,11.12,5.45,9.19A3.52,3.52,0,0,1,4.73,4.7,9.5,9.5,0,0,1,6.94,2a4.91,4.91,0,0,0,.72-.64h.07l.12.15Q19.94,13.63,32,25.8c.24.24.34.16.52,0q12-12.15,24.1-24.27c.06-.06.11-.14.17-.2h.07c0,.13.16.17.26.25a9.76,9.76,0,0,1,2.73,3.26,3.74,3.74,0,0,1,.42,2.08A3.9,3.9,0,0,1,59,9.26L37.56,30.86c-.2.2-.22.3,0,.51l7.84,7.89a.37.37,0,0,0,.51.1,11.74,11.74,0,0,1,10.73-.16A12,12,0,0,1,63.45,48C63.6,48.71,63.6,49.42,63.71,50.12Zm-12.3,8.62a8.4,8.4,0,1,0-8.32-8.46A8.38,8.38,0,0,0,51.41,58.74Zm-38.86,0a8.4,8.4,0,1,0-8.33-8.43A8.39,8.39,0,0,0,12.55,58.74Z"
    ,
  style: {
    marginRight: "10px"
  }
};
export const EmptyLayerIcon = SvgIconBase(iconData);
